var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 74,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#827127",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M41.354 11.338v-3.88c0-3.92-3.178-7.099-7.078-7.099s-7.078 3.178-7.078 7.1v3.879M44.08 11.957c1.196 0 2.187.97 2.187 2.187v14.57c0 1.197-.97 2.187-2.188 2.187H24.454a2.175 2.175 0 0 1-2.187-2.187v-14.57c0-1.197.97-2.187 2.187-2.187zM62.239 40.415H6.294A6.294 6.294 0 0 0 0 46.708v19.356a6.294 6.294 0 0 0 6.294 6.294H62.24a6.294 6.294 0 0 0 6.294-6.294V46.71a6.294 6.294 0 0 0-6.294-6.295M10.834 61.629l3.797-5.242M14.632 56.387l-6.15-2.002M14.63 56.387v-6.46M14.63 56.387l6.15-2.002M14.63 56.387l3.798 5.242M30.459 61.629l3.797-5.242M34.257 56.387l-6.15-2.002M34.255 56.387v-6.46M34.255 56.387l6.15-2.002M34.255 56.387l3.797 5.242M50.084 61.629l3.797-5.242M53.881 56.387l-6.15-2.002M53.882 56.387v-6.46M53.882 56.387l6.15-2.002M53.882 56.387l3.797 5.242"
  })));
};
export default SvgGroup;